module.exports = __webpack_public_path__ + "img/blinded.fd2f0709.svg";